// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__K_Xoi","foto":"styles_foto__oUMEJ"};